// Book data - Edit this file to update book information on the website

export const books = [
  {
    id: 'journey-within',
    title: 'A Journey Within',
    author: 'Heeloly Upasani',
    series: 'Standalone',
    bookNumber: null,
    coverImage: 'https://customer-assets.emergentagent.com/job_writer-hub-11/artifacts/f4zt45d6_book2.jpg',
    blurb: `"A Journey Within" is a heartfelt collection of poetry that explores the depths of life, dreams, self-discovery, and love. Through verses that touch on resilience, emotions, and the beauty of the human experience, this book invites readers to reflect, heal, and embrace their own inner journey. With themes of personal growth, hope, and introspection, these poems serve as a reminder that life is a canvas of endless possibilities. Whether celebrating victories, facing struggles, or cherishing relationships, "A Journey Within" captures the essence of what it means to truly live. Let these words be your companion in moments of reflection, a source of comfort, and an inspiration to follow your dreams fearlessly.`,
    amazonLink: '#',
    goodreadsLink: '#',
    status: 'available',
    releaseDate: '2024',
    genres: ['Poetry', 'Self-Discovery', 'Personal Growth']
  }
];

export const comingSoonBooks = [
  {
    id: 'coming-soon-1',
    title: 'Coming Soon',
    author: 'Heeloly Upasani',
    series: 'TBA',
    bookNumber: null,
    coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=600&fit=crop',
    blurb: 'A new story is brewing... Stay tuned for updates on this upcoming release.',
    amazonLink: null,
    goodreadsLink: null,
    status: 'coming-soon',
    releaseDate: 'TBA',
    genres: []
  }
];
